var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('h2',[_vm._v("En este programa")]),_c('ul',[_vm._l((_vm.nodes),function(node){return [_c('Node',{key:node.code,attrs:{"node":node},on:{"update-tree":_vm.updateTree}})]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }